import { withLayoutProductGridProps } from 'viewModel/content/layoutProductGrid/withLayoutProductGridProps';
import LayoutProductGrid from 'components/Content/ContentLayout/LayoutProductGrid/LayoutProductGrid';

export default withLayoutProductGridProps(LayoutProductGrid);
